import CircledX from './circled-x';

export * from './circled-x';
export default CircledX;
